import axios from "axios";
import Cookies from "js-cookie";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL, // from .env file
  timeout: 20000, // 20s — a hung request used to stay pending forever, which
  // exhausts the browser's ~6 concurrent-connections-per-domain limit and
  // makes every other request/page queue up behind it. Failing fast here
  // lets the existing try/catch fallbacks (error states, "not found", etc.)
  // kick in instead of an indefinite blank/loading hang.
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor
apiClient.interceptors.request.use(
  (config: any) => {
    const excludedPaths = [
      "/login",
      "/reset-password",
      "/forgot-password",
      "/register",
    ];

    const shouldSkipToken = excludedPaths.some((path) =>
      config.url?.includes(path)
    );

    if (!shouldSkipToken) {
      const token = Cookies.get("authToken");
      if (token) {
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${token}`,
        };
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Your service methods
// `config` (optional, last param) merges into the axios request config —
// in particular `{ timeout: <ms> }` to override the 20s default above for
// a specific slow call (e.g. Article Audit/Fix, which chains several live
// page fetches and AI calls and can genuinely take well over 20s). Without
// this override, a slow-but-otherwise-successful request would be killed
// client-side before the server's real response — including a real error
// message — ever arrives, which is exactly what was happening to Audit/Fix.
export const apiService = {
  get: (url: string, params?: object, config?: object) => apiClient.get(url, { params, ...config }),
  post: (url: string, data: object, config?: object) => apiClient.post(url, data, config),
  put: (url: string, data: object, config?: object) => apiClient.put(url, data, config),
  delete: (url: string, data?: object, config?: object) => apiClient.delete(url, { data, ...config }),
};